import { z } from 'zod'
import { useParsedStorage } from '../../../../core'
import { useCurrentUser } from '../../../utils/currentUserContext'
import type { UserEducationId } from '../userEducationPriority'
const USER_EDUCATION_DISMISSED_AT_KEY_PREFIX = 'joyful-user-education'
const DismissedAtSchema = z.iso.datetime().nullable()

export interface UseDismissibleUserEducationParams {
  educationId: UserEducationId
}

export function useDismissibleUserEducation({
  educationId,
}: UseDismissibleUserEducationParams) {
  const currentUser = useCurrentUser()
  const [dismissedAt, setDismissedAt] = useParsedStorage(
    `${USER_EDUCATION_DISMISSED_AT_KEY_PREFIX}-${currentUser.id}-${educationId}-dismissed-at`,
    {
      initialValue: null,
      schema: DismissedAtSchema,
      strategy: 'local',
    },
  )

  const dismiss = () => {
    const nextDismissedAt = new Date().toISOString()
    setDismissedAt(nextDismissedAt)
  }

  return {
    actions: {
      dismiss,
    },
    state: {
      dismissedAt,
    },
  }
}
